module.exports = __webpack_public_path__ + "img/Jump Casting90.68f56352.jpg";